import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { TrWrapperTwoColumnsModule } from '@toro/common/shared/components';
import { LayerService } from '@toro/common/shared/services/LayerService';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DraftComponent } from './draft/draft.component';
import { DraftSuccessComponent } from './draftsuccess/draftsuccess.component';
import { DraftErrorComponent } from './drafterror/drafterror.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpService } from '@toro/common/shared/services/http/http.service';
import { TrInputsModule } from '@toro/common/shared/components';
import {
  HubLogoModule,
  TrLoadingOverlayModule,
  SvgIconModule,
} from '@toro/common/shared/components';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { WithdrawalHistoryComponent } from './withdrawal-history/withdrawal-history.component';
import { WithdrawalHistoryItem } from './withdrawal-history/withdrawal-history-item/withdrawal-history-item.component';
import { WithdrawalHistoryItemIconComponent } from './withdrawal-history/withdrawal-history-item-icon/withdrawal-history-item-icon';
import { AbsoluteValuePipeModule } from '@toro/common/shared/pipes/absolute-value/absolute-value.module';

import { WithdrawalHistoryPageComponent } from './withdrawal-history/withdrawal-history-page.component';
import { WithdrawalLoConfirmComponent } from './withdrawal-lo-confirm/withdrawal-lo-confirm.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HubLogoModule,
    HttpClientModule,
    RouterModule,
    TrWrapperTwoColumnsModule,
    TrLoadingOverlayModule,
    SvgIconModule,
    TrInputsModule,
    AbsoluteValuePipeModule,
  ],
  declarations: [
        DraftComponent,
        DraftErrorComponent,
        DraftSuccessComponent,
        WithdrawalHistoryComponent,
        WithdrawalHistoryItem,
        WithdrawalHistoryItemIconComponent,
        WithdrawalHistoryPageComponent,
        WithdrawalLoConfirmComponent
    ],
  providers: [LayerService, HttpService, DialogsService, HttpClient, { provide: MatDialogRef, useValue: {} }],
  entryComponents: [
    DraftSuccessComponent,
    WithdrawalHistoryComponent,
    WithdrawalLoConfirmComponent,
  ]
})
export class DraftModule {}
